<template>
<div id="app" class="site container hfeed dl-page">
  <HeadNav selectedLanguage="en" page="download" />

  <div id="content" class="site-content page-primary">
    <article id="article" class="center page-main-narrow">
      <section id="downloadpage">
        <Breadcrumbs :items="crumbs" />

        <section class="download-content prose-block">
          <header class="download-header">
            <h1>Download GB WhatsApp APK v18.80</h1>
            <p class="intro">
              Download the latest <strong>GB WhatsApp App v18.80</strong> for Android. Check the basic file information below, then use the download button to save the APK to your device.
            </p>
          </header>

          <div class="app-info-table">
            <table>
              <thead>
                <tr>
                  <th scope="col">APK Information</th>
                  <th scope="col">Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Version</th>
                  <td>v18.80</td>
                </tr>
                <tr>
                  <th scope="row">Platform</th>
                  <td>Android</td>
                </tr>
                <tr>
                  <th scope="row">Android</th>
                  <td>6.0+</td>
                </tr>
                <tr>
                  <th scope="row">File Type</th>
                  <td>APK</td>
                </tr>
                <tr>
                  <th scope="row">Updated</th>
                  <td>Sep 2026</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="cta-band top">
            <button type="button" class="download-btn" @click="downloadfrom('top')">
              <img src="@/assets/android.webp" alt="">
              Download GB WhatsApp App
            </button>
          </div>

          <p>
            Before installing, back up any important WhatsApp chats and media.
            <router-link to="/"><strong>GB WhatsApp</strong></router-link>
            is a third-party modified app and is not available through the Google Play Store.
          </p>

          <h2>How to Install GB WhatsApp app</h2>
          <p>After downloading the APK, follow these simple steps:</p>
          <ol class="steps">
            <li><strong>Allow installation</strong> - If Android blocks the APK, allow your browser or file manager to install apps from that source.</li>
            <li><strong>Install the APK</strong> - Open the downloaded file and tap <strong>Install</strong>.</li>
            <li><strong>Verify your number</strong> - Open GB WhatsApp and complete phone number verification.</li>
            <li><strong>Restore your chats</strong> - If a compatible backup is available, follow the restore options after verification.</li>
          </ol>
          <p>
            Keep your previous WhatsApp data until you have checked that your important chats and media are available.
          </p>

          <h2>Common GBWhatsApp Installation Problems</h2>
          <div class="faq-mini">
            <p><strong>Why won't GB WhatsApp install?</strong> Check your Android version and available storage. An incompatible APK or another WhatsApp installation can also cause conflicts.</p>
            <p><strong>Why does Android block the APK?</strong> Your device may not allow installations from that source. Enable the required installation permission and try again.</p>
            <p><strong>Why isn't the verification code arriving?</strong> Check your phone number, country code, and mobile connection. Wait before requesting another code.</p>
            <p><strong>Why can't I restore my chats?</strong> Backup compatibility can vary between WhatsApp and modified clients. Keep your original backup before switching.</p>
            <p><strong>Why does the app crash after installation?</strong> Make sure your Android version is supported and that the APK installed correctly. If the problem continues, try a compatible build.</p>
          </div>

          <div class="cta-band bottom">
            <button type="button" class="download-btn" @click="downloadfrom('bottom')">
              <img src="@/assets/android.webp" alt="">
              Download GB WhatsApp App
            </button>
          </div>
        </section>
      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/page-narrow-layout.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Download',
  components: {
    HeadNav,
    Breadcrumbs,
  },
  data() {
    return {
      pageName: 'download',
      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
      crumbs: [
        { label: 'Home', to: '/' },
        { label: 'Download', to: '' },
      ],
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          this.apk = res.code == 200 ? res.data.apk : process.env.VUE_APP_GBLINK;
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          this.apk = res.code == 200 && type == 1 ? res.data.apk : process.env.VUE_APP_GBLINK;
        });
    },
    download() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dl-page .download-content {
  width: 100%;
  margin: 1rem auto;
  padding: 0;
  background: #fff;
}
.prose-block {
  line-height: 1.7;
  color: #222;
  font-size: 1.05rem;
}
.intro {
  text-align: left;
  margin: 0 auto 1.5rem;
}
.download-header h1 {
  color: #25d366;
  font-size: 2.15rem;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
  margin-bottom: 1rem;
}
h2 {
  color: #128c7e;
  font-size: 1.45rem;
  margin-top: 2.25rem;
}
.cta-band {
  display: flex;
  justify-content: center;
  margin: 1.75rem 0;
}
.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  color: white;
  border: none;
  padding: 16px 28px;
  border-radius: 8px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
}
.download-btn img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}
.app-info-table {
  display: flex;
  justify-content: center;
  margin: 1rem 0 1.5rem;
  overflow-x: auto;
}
.app-info-table table {
  width: 320px;
  max-width: 100%;
  border-collapse: collapse;
  font-size: 0.94rem;
  line-height: 1.3;
}
.app-info-table th,
.app-info-table td {
  padding: 0.35rem 0.45rem;
  text-align: left;
  border: 1px solid #cfcfcf;
  vertical-align: top;
}
.app-info-table th {
  background: transparent;
  color: #111;
  font-weight: 600;
  width: 50%;
}
.steps {
  background: #f8f9fa;
  padding: 1.25rem 1.25rem 1.25rem 2rem;
  border-radius: 8px;
  border-left: 4px solid #25d366;
}
.faq-mini p {
  margin: 0.85rem 0;
}
.faq-mini strong {
  display: block;
  margin-bottom: 0.15rem;
}
a {
  color: #128c7e;
  font-weight: 600;
}
@media (max-width: 768px) {
  .download-header h1 {
    font-size: 1.75rem;
  }
  .download-btn {
    padding: 14px 22px;
    font-size: 15px;
  }
}
</style>
